import styled from "styled-components";
import { ProgressCardsProps } from "./types";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { getNumberFormat } from "../../../utils";

export const ProgressCard: React.FC<ProgressCardsProps> = ({
  value,
  type,
  date,
  onDeleteClick,
  isIncome = true,
}) => {
  return (
    <Wrapper>
      <Icon onClick={onDeleteClick}>
        <DeleteForeverIcon />
      </Icon>
      <Row>
        <span>Progress Date:</span>
        <span>{date}</span>
      </Row>
      <Row>
        <span>{type}:</span>
        <span>{(isIncome ? " " : "-") + getNumberFormat(value)} €</span>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding: 16px 24px 8px 12px;
  color: var(--color-text);
  background: var(--color-background-2);
  box-shadow: 2px 4px 12px hsl(0deg 0% 0% / 0.1);
  border-radius: 4px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 16px;
`;

const Icon = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  color: var(--color-error);
  cursor: pointer;
`;
